import { EstateStatusItemState } from '../generated/graphql';
import { EstateStatusChecklistItem } from './types';

export const ESTATE_STATUS_PERCENT_SCALE = 100;
export const ESTATE_STATUS_SCORE_DECIMAL_MULTIPLIER = 10;
export const ESTATE_STATUS_TEMPLATE_TARGET_WEIGHT = 100;
export const ESTATE_STATUS_AUTOSAVE_DEBOUNCE_MS = 900;
export const ESTATE_STATUS_DETAIL_DATE_PICKER_OFFSET_YEARS = -25;
export const ESTATE_STATUS_DETAIL_EXPAND_ANIMATION_DURATION_SECONDS = 0.18;
export const ESTATE_STATUS_ATTACHMENT_FALLBACK_CREATED_AT = new Date(0).toISOString();

export type EstateStatusDefaultChecklistLabelI18nKey =
  | 'default-checklist-will'
  | 'default-checklist-trust'
  | 'default-checklist-financial-poa'
  | 'default-checklist-healthcare-directive'
  | 'default-checklist-beneficiaries'
  | 'default-checklist-guardianship';

export const ESTATE_STATUS_DEFAULT_CHECKLIST_ITEMS: Array<
  Omit<EstateStatusChecklistItem, 'label'> & { labelI18nKey: EstateStatusDefaultChecklistLabelI18nKey }
> = [
  {
    id: 'will',
    labelI18nKey: 'default-checklist-will',
    weight: 20,
    state: EstateStatusItemState.No,
    lastReviewedAt: null,
    note: '',
    attachmentLinks: [],
  },
  {
    id: 'trust',
    labelI18nKey: 'default-checklist-trust',
    weight: 20,
    state: EstateStatusItemState.No,
    lastReviewedAt: null,
    note: '',
    attachmentLinks: [],
  },
  {
    id: 'financial-poa',
    labelI18nKey: 'default-checklist-financial-poa',
    weight: 15,
    state: EstateStatusItemState.No,
    lastReviewedAt: null,
    note: '',
    attachmentLinks: [],
  },
  {
    id: 'healthcare-directive',
    labelI18nKey: 'default-checklist-healthcare-directive',
    weight: 15,
    state: EstateStatusItemState.No,
    lastReviewedAt: null,
    note: '',
    attachmentLinks: [],
  },
  {
    id: 'beneficiaries',
    labelI18nKey: 'default-checklist-beneficiaries',
    weight: 20,
    state: EstateStatusItemState.No,
    lastReviewedAt: null,
    note: '',
    attachmentLinks: [],
  },
  {
    id: 'guardianship',
    labelI18nKey: 'default-checklist-guardianship',
    weight: 10,
    state: EstateStatusItemState.Na,
    lastReviewedAt: null,
    note: '',
    attachmentLinks: [],
  },
];

export function getEstateStatusDefaultChecklist(
  t: (key: EstateStatusDefaultChecklistLabelI18nKey) => string
): EstateStatusChecklistItem[] {
  return ESTATE_STATUS_DEFAULT_CHECKLIST_ITEMS.map(({ labelI18nKey, ...item }) => ({
    ...item,
    label: t(labelI18nKey),
  }));
}

export function getEstateStatusDefaultHouseholdChecklist(
  t: (key: EstateStatusDefaultChecklistLabelI18nKey) => string
): EstateStatusChecklistItem[] {
  return getEstateStatusDefaultChecklist(t).map((item) => ({
    ...item,
    state: EstateStatusItemState.Na,
    lastReviewedAt: null,
    note: '',
    attachmentLinks: [],
  }));
}
